
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRoutePlanProposal as ObiRoutePlanProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-route-plan-proposal.js';
 
 
 

 
 export const ObiRoutePlanProposal = createComponent({
   react: React,
   tagName: 'obi-route-plan-proposal',
   elementClass: ObiRoutePlanProposalElement,
   events: {
     
   }
  });
 
 